/**
 * Created by inonstelman on 12/28/14.
 */

(function () {
    'use strict';

    // @ngInject
    Services.GoogleApi = function GoogleApi($window, Gon, ThirdPartyLoaderService) {
        var url = "https://maps.googleapis.com/maps/api/js?key=" + Gon.google_api_api_key + "&libraries=places";
        return ThirdPartyLoaderService.loadUrlPromise(url, function() {return $window.google;});
    };

}());
